export default "__VITE_ASSET__e58c544b__"